import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { DownArrow } from "../../assets/icons";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function AppSelect({
  label,
  options,
  onHandleSelect,
  selected,
  placeholder
}: {
  label: string;
  options: { id: string; name: string; value: string; label: string }[];
  selected: { id?: string; name: string; value: string; label: string };
  onHandleSelect?: any;
  placeholder: string
}) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredOptions = options.filter((option) =>
    option.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Listbox value={selected} onChange={(option) => onHandleSelect(option)}>
      {({ open }) => (
        <>
          <Listbox.Label className="block text-sm font-gt-w-medium leading-6 text-gray-900">
            {label}
          </Listbox.Label>
          <div className="relative mt-1">
            <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-4 pl-5 pr-40 text-left text-gray-900  ring-1 ring-inset ring-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-600 sm:text-sm sm:leading-6">
              <span className="block truncate font-gt-w-regular text-sm capitalize">
                {selected?.name ? selected?.name : placeholder }
              </span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <DownArrow />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-lg bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                <div className="sticky z-10 top-0 bg-white px-4 py-2">
                  <input
                    type="text"
                    className="w-full rounded-md border border-neutral-300 p-3 text-sm focus:border-primary-600 focus:outline-none focus:ring-1 focus:ring-primary-600"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                {filteredOptions.length === 0 ? (
                  <div className="py-2 px-4 text-sm text-neutral-500">No options found</div>
                ) : (
                  filteredOptions.map((option) => (
                    <Listbox.Option
                      key={option.id}
                      className={({ active }) =>
                        classNames(
                          active
                            ? "bg-primary-100 text-primary-600 font-gt-w-medium"
                            : "text-gray-900",
                          "relative cursor-default select-none py-3 pl-4 pr-4 font-gt-w-regular text-base capitalize"
                        )
                      }
                      value={option}
                    >
                      {({ selected, active }) => (
                        <>
                          <span
                            className={classNames(
                              selected ? "font-semibold" : "font-normal",
                              "block truncate"
                            )}
                          >
                            {option.name}
                          </span>

                          {selected ? (
                            <span
                              className={classNames(
                                active ? "text-white" : "text-indigo-600",
                                "absolute inset-y-0 left-0 flex items-center pl-1.5"
                              )}
                            ></span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))
                )}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}
